import { AxiosResponse } from "axios";
import { IBulkOrdersResponse, IBulkOrderWithItems } from "domain/BulkOrders";
import { httpApi } from "./http.api";

export const getBulkOrdersByDate = async (params: {
  selected_date: string;
  document?: string;
  workSchedule?: string;
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  const { selected_date, document, workSchedule } = params;

  let url = `BulkOrders/GetBulkOrdersByDate?selected_date=${selected_date}`;

  if (document && document !== 'All') {
    url += `&document=${document}`;
  }

  if (workSchedule && workSchedule !== 'All') {
    url += `&work_schedule=${workSchedule}`;
  }

  const response = await httpApi.get(url);

  const parsedData = response.data.data.map((order: IBulkOrderWithItems) => ({
    ...order,
    recurrent_bulk_order_items: order.recurrent_bulk_order_items
      ? JSON.parse(order.recurrent_bulk_order_items)
      : []
  }));

  return {
    ...response,
    data: {
      ...response.data,
      data: parsedData
    }
  };
};

export const updateBulkOrders = async (data: {
  selected_date: string;
  bulk_order_items: {
    recurrent_bulk_order_id: number;
    sku_id: number;
    final_by_account_amount?: number | string;
  }[];
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  return httpApi.put("BulkOrders", data);
};

export const updateClientBulkOrders = async (data: {
  selected_date: string;
  bulk_order_items: {
    recurrent_bulk_order_id: number;
    sku_id: number;
    final_by_account_amount?: number | string;
  }[];
}): Promise<AxiosResponse<IBulkOrdersResponse>> => {
  return httpApi.put("ClientBulkOrders", data);
};